export const USER_RESET = 'user.RESET';
export const USER_CONFIRMED = 'user.USER_CONFIRMED';
export const USER_UPDATED = 'user.USER_UPDATED';
export const USER_STARTED_LOGIN_PROCESS = 'user.USER_STARTED_LOGIN_PROCESS';
export const USER_LOADING = 'user.USER_LOADING';
export const USER_LOGGED_IN = 'user.LOGGED_IN';
export const USER_LOGGED_OUT = 'user.LOGGED_OUT';
export const USER_DELETED = 'user.USER_DELETED';
export const USER_ERROR = 'user.ERROR';
export const ALL_TACKS_PAUSED = 'user.ALL_TACKS_PAUSED';
export const ALL_TACKS_RESUMED = 'user.ALL_TACKS_RESUMED';
export const USER_ACCOUNT_RETRIEVED = 'user.USER_ACCOUNT_RETRIEVED';



// WEBPACK FOOTER //
// ./src/stores/user/action_types.js